import {Input} from 'antd'

import {Button, Form, FormItem, Box} from 'common/components'
import {FIELD_RULES, PASSWORD_FIELD_RULES} from 'common/constants'
import {useUpdateProfile} from '..'

interface BorrowerPasswordChangeFormProps {
  onClose: () => void
}

export default function BorrowerPasswordChangeForm({
  onClose,
}: BorrowerPasswordChangeFormProps) {
  const {mutate: updateProfile, isMutating} = useUpdateProfile(onClose)

  const handleFinish = (values: any) => updateProfile(values)

  return (
    <Form onFinish={handleFinish}>
      <Box mb={24}>
        <FormItem
          name="oldPassword"
          label="Current password"
          rules={FIELD_RULES}
        >
          <Input.Password autoFocus />
        </FormItem>
        <FormItem
          name="password"
          label="New password"
          help="Minimum 8 characters, 1 capital letter, letters and numbers"
          rules={PASSWORD_FIELD_RULES}
        >
          <Input.Password />
        </FormItem>
      </Box>
      <Button block htmlType="submit" loading={isMutating}>
        Save new password
      </Button>
    </Form>
  )
}
